import { useResourceOne } from "@/hooks";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useAuthContext } from "@/providers/auth-provider";
import { RESOURCE_TYPE_TENANTS } from "@/resources-def";
import { Card, Col, Flex, Row, Space, Statistic, Table, Tag } from "antd";
import { RefreshButton } from "../common/RefreshButton";
import { t } from "i18next";

const RESOURCE_NAME = RESOURCE_TYPE_TENANTS;

export const TenantHome = () => {
  const { rootState, tenantName } = useResourceContext();
  const { user } = useAuthContext();
  const { data, isLoading, isError } = useResourceOne({
    skip: user?.tenant === "__root__" && !rootState.tenantMode,
    resource: RESOURCE_NAME,
    id: tenantName,
  });
  console.log(data, isLoading, isError);
  const instanceTableColumns = [
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
  ];
  const instanceDistribution = data?.summary || [];

  const getMFALabel = () => {
    const mfas = [];
    if(data?.email_mfa)
      mfas.push("Email");
    if(data?.app_mfa)
      mfas.push("App");
    const label = mfas.join(", ");
    return label? label: "None";
  }
  return (
    <div>
      <Flex justify="space-between">
        <h1>Summary</h1>
        <RefreshButton resource={RESOURCE_NAME} id={tenantName} />
      </Flex>
      <Row gutter={16}>
        <Col span={8}>
          <Card loading={isLoading} title="Tenant Name">
            <Space>
              <Statistic value={data?.name || "N/A"} />
              <Tag>{t(`subscription.type.${data?.subscription}`, data?.subscription)}</Tag>
            </Space>
          </Card>
        </Col>
        <Col span={8}>
          <Card loading={isLoading} title="MFA">
            <Statistic value={getMFALabel()} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Card loading={isLoading} title="User Count">
            <Statistic value={data?.users || 0} />
          </Card>
        </Col>
        <Col span={8}>
          <Card loading={isLoading} title="Total Instances">
            <Statistic value={data?.instances || 0} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col xxl={12} xl={16} md={24}>
          <Card loading={isLoading} title="Instance Distribution">
            <Table
              dataSource={instanceDistribution}
              columns={instanceTableColumns}
              pagination={false}
              rowKey="region"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};
